import { stylePropertyPrefixes } from '../utilities/swan-style.utils.js';
var ROOT_CLASSNAMES = {
  base: 'swan',
  darkMode: "swan-".concat(stylePropertyPrefixes.darkMode),
  lightMode: "swan-".concat(stylePropertyPrefixes.lightMode),
  themeHoliday: "swan-theme-holiday"
};
export { ROOT_CLASSNAMES };